import React from 'react';
import BookEpub from './BookEpub';
import BookPdf from './BookPdf';
export var Book = function (_a) {
    var type = _a.type, url = _a.url, title = _a.title, loc = _a.loc, closeBook = _a.closeBook, downloadBook = _a.downloadBook;
    return (React.createElement(React.Fragment, null,
        type === 'pdf' && (React.createElement(BookPdf, { type: type, url: url, title: title, closeBook: closeBook, downloadBook: downloadBook })),
        type === 'epub' && (React.createElement(BookEpub, { type: type, url: url, title: title, closeBook: closeBook, downloadBook: downloadBook }))));
};
export default Book;
